import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
    Sentry.init({
        dsn: dsn,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Performance Monitoring
        tracesSampleRate: 0.2,
        // Session Replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE || 'production',
        // Bizim düzeltemeyeceğimiz / beklenen durumlar (her biri Sentry'de issue ve e-posta açıyordu)
        ignoreErrors: [
            'Error creating WebGL context',        // WebGL'siz cihaz: 3D sahne yerine yedek görsel gösterilir
            'Java object is gone',                 // Instagram/Facebook uygulama içi tarayıcısının kendi köprüsü
            'messaging/unsupported-browser',       // Web push'u desteklemeyen tarayıcı (firebase.ts isSupported ile atlar)
        ],
        denyUrls: [/^iabjs:\/\//],                 // Uygulama içi tarayıcıların enjekte ettiği betikler
    });
    console.log("⚡ [Sentry] initialized successfully.");
} else {
    console.warn("⚠️ [Sentry] VITE_SENTRY_DSN not found. Sentry is disabled.");
}

/**
 * Yeni deploy'dan sonra açık kalan sekme, artık sunucuda olmayan eski JS parçasını ister
 * ("Failed to fetch dynamically imported module" / "Importing a module script failed" / text/html MIME).
 * Vite bunu vite:preloadError ile bildirir: sayfayı yenile. Yavaş bağlantıda (deploy sonrası Hosting yavaşken) güncel
 * parça da inemeyebiliyor: 5 dakikada en fazla 3 kez, giderek uzayan aralıkla dene (2026-10-13: tek yenileme hakkı
 * 24 sn sonraki ikinci hatada bitmiş, ekran boş kalmıştı). Sonrasında hata App'teki AppErrorBoundary'ye düşer.
 */
if (typeof window !== 'undefined') {
    window.addEventListener('vite:preloadError', (event) => {
        try {
            const prev = JSON.parse(sessionStorage.getItem('kpss_chunk_reload') || 'null');
            const fresh = !prev || typeof prev !== 'object' || Date.now() - Number(prev.first) > 5 * 60_000;
            const state = fresh ? { first: Date.now(), n: 0 } : { first: Number(prev.first), n: Number(prev.n) || 0 };
            if (state.n < 3) {
                state.n += 1;
                sessionStorage.setItem('kpss_chunk_reload', JSON.stringify(state));
                event.preventDefault();
                (window as any).__kpssChunkReloading = true; // AppErrorBoundary hata yerine "yükleniyor" gösterir
                setTimeout(() => window.location.reload(), 1000 * state.n);
            }
        } catch { /* depolama yoksa Vite hatayı olduğu gibi fırlatır */ }
    });
}

export { Sentry };
